import AdminDeleteButton from '../../common/AdminDeleteButton';
import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const RemarkOptionList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { remarkOptions, total, page } = data;

    return (
        <>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Remark Option</th>
                            <th>Description</th>
                            <th>Sort Order</th>
                            <th>Status</th>
                            <th>Modified By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {remarkOptions?.length > 0 ? (
                            remarkOptions.map((item) => (
                                <tr key={item.ID}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle bg-light text-primary">
                                                {item.OPTION_NAME?.charAt(0).toUpperCase()}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{item.OPTION_NAME}</td>
                                    <td>{item.DESCRIPTION || '-'}</td>
                                    <td>{item.SORT_ORDER || '-'}</td>
                                    <td>
                                        <span
                                            className={`badge rounded-pill ${item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'}`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item px-2">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editRemarkOptionMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page,
                                                        },
                                                    }}
                                                    title="Edit Remark Option"
                                                >
                                                    <i className="bx bx-edit" />
                                                </Link>
                                            </li>
                                            <li className="list-inline-item px-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    onClick={() => onChangeVisibility(item)}
                                                    style={{ color: 'red' }}
                                                    title={item.IS_ACTIVE ? 'Deactivate Remark Option' : 'Restore Remark Option'}
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </button>
                                            </li>
                                        <li className="list-inline-item px-2"><AdminDeleteButton resource="remarkOption" entryId={item.ID} label="remarkOption" /></li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">No remark options found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </>
    );
};

export default withRouter(RemarkOptionList);
